import moment from "moment";
import {
  collection,
  where,
  query,
  getDocs,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  limit,
  increment,
} from "firebase/firestore/lite";

import { db } from "senf-shared";
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect";
import { LIKE_IDEA, UNLIKE_IDEA, SET_ERRORS } from "../types";

export const likeIdea =
  (project, ideaMapId, ideaId, user) => async (dispatch) => {
    if (!project) throw new Error("No project provided in likeIdea");
    if (!project.organizationId)
      throw new Error("No organizationId provided in likeIdea");
    if (!project.projectId)
      throw new Error("No projectId provided in likeIdea");
    if (!ideaId) throw new Error("No ideaId provided in likeIdea");
    const ideaDocRef = doc(
      db,
      `organizations/${project.organizationId}/projects/${project.projectId}/ideas/${ideaId}`
    );
    const ideaDocSnapshot = await getDoc(ideaDocRef);

    const likeRef = collection(db, "likes");
    const likeQuery = query(
      likeRef,
      where("ideaId", "==", ideaId),
      where("userId", "==", user.userId),
      limit(1)
    );
    const likeQuerySnapshot = await getDocs(likeQuery);

    if (!ideaDocSnapshot.exists()) {
      dispatch({
        type: SET_ERRORS,
        payload: {
          message: "Idea not found",
        },
      });
      throw new Error("Idea not found in likeIdea");
    }

    const idea = ideaDocSnapshot.data();

    const ageCapture =
      user.age !== ""
        ? moment()?.diff(moment(user.age, "YYYY"), "years")
        : null;

    if (!likeQuerySnapshot.empty) {
      dispatch(unlikeIdea(project, ideaMapId, ideaId, user));
    } else {
      idea.likeCount++;

      const documendData = {
        ideaId,
        ideaMapId,
        userHandle: user.handle,
        userId: user.userId,
        createdAt: new Date().toISOString(),
        gender: user.gender || null,
        age: ageCapture,
        userPostcode: user.postcode || null,
        topic: idea.topic,
        device: isMobileOnly
          ? "mobile"
          : isTablet
            ? "tablet"
            : isDesktop
              ? "desktop"
              : "other",
      };
      if (idea.projectId) {
        documendData.projectId = idea.projectId;
      }
      if (user.utm_id) {
        documendData.utm_id = user.utm_id;
      }

      await addDoc(collection(db, "likes"), documendData);

      await updateDoc(ideaDocSnapshot.ref, {
        likeCount: increment(1),
      });
      dispatch({
        type: LIKE_IDEA,
        payload: idea,
      });
    }
  };

// Unlike an idea
export const unlikeIdea =
  (project, ideaMapId, ideaId, user) => async (dispatch) => {
    if (!project) throw new Error("No project provided in unlikeIdea");
    if (!project.organizationId)
      throw new Error("No organizationId provided in unlikeIdea");
    if (!project.projectId)
      throw new Error("No projectId provided in unlikeIdea");
    if (!ideaId) throw new Error("No ideaId provided in unlikeIdea");
    const ideaDocRef = doc(
      db,
      `organizations/${project.organizationId}/projects/${project.projectId}/ideas/${ideaId}`
    );
    const ideaDocSnapshot = await getDoc(ideaDocRef);

    const likeRef = collection(db, "likes");
    const likeQuery = query(
      likeRef,
      where("ideaId", "==", ideaId),
      where("userId", "==", user.userId),
      limit(1)
    );
    const likeQuerySnapshot = await getDocs(likeQuery);

    if (!ideaDocSnapshot.exists()) {
      dispatch({
        type: SET_ERRORS,
        payload: {
          message: "Idea not found",
        },
      });
    }

    const idea = ideaDocSnapshot.data();

    if (likeQuerySnapshot.empty) {
    } else {
      idea.likeCount--;

      await deleteDoc(doc(db, "likes", likeQuerySnapshot.docs[0].id));

      await updateDoc(ideaDocSnapshot.ref, {
        likeCount: increment(-1),
      });
      dispatch({
        type: UNLIKE_IDEA,
        payload: idea,
      });
    }
  };
